"use client";

import type { FormEvent, ReactNode } from "react";

export interface GlassInputBarProps {
	readonly value: string;
	readonly onChange: (value: string) => void;
	readonly placeholder?: string;
	readonly label?: string;
	readonly leading?: ReactNode;
	readonly trailing?: ReactNode;
	readonly onSubmit?: () => void;
	readonly className?: string;
}

/**
 * GlassInputBar — single-line glass input with leading/trailing slots and an
 * optional submit handler. Mirrors `DSGlassInputBar` on iOS.
 */
export function GlassInputBar({
	value,
	onChange,
	placeholder,
	label,
	leading,
	trailing,
	onSubmit,
	className = "",
}: Readonly<GlassInputBarProps>) {
	return (
		<form
			className={`ds-input-bar ${className}`.trim()}
			onSubmit={(event: FormEvent<HTMLFormElement>) => {
				event.preventDefault();
				onSubmit?.();
			}}
			style={{
				display: "flex",
				alignItems: "center",
				gap: "var(--ds-space-md)",
				minHeight: "50px",
				padding: "0 var(--ds-space-lg)",
				border: "1px solid var(--ds-glass-stroke)",
				borderRadius: "var(--ds-radius-full)",
				background: "var(--ds-glass-soft)",
				backdropFilter: "blur(20px)",
				WebkitBackdropFilter: "blur(20px)",
			}}
		>
			{leading === undefined ? null : <span aria-hidden="true">{leading}</span>}
			<input
				aria-label={label ?? placeholder ?? "输入"}
				placeholder={placeholder}
				value={value}
				onChange={(event) => onChange(event.currentTarget.value)}
				style={{
					flex: 1,
					minWidth: 0,
					border: 0,
					outline: 0,
					background: "transparent",
					color: "var(--ds-text-primary)",
					font: "inherit",
					padding: "13px 0",
				}}
			/>
			{trailing === undefined ? null : <span>{trailing}</span>}
		</form>
	);
}
